import { render } from "./AddInvestmentPage.vue?vue&type=template&id=0d0a949c&scoped=true"
import script from "./AddInvestmentPage.vue?vue&type=script&lang=js"
export * from "./AddInvestmentPage.vue?vue&type=script&lang=js"

import "./AddInvestmentPage.vue?vue&type=style&index=0&id=0d0a949c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d0a949c"]])

export default __exports__